import { useMemo } from 'react';

import useUserTimeZone from '@src/hooks/useUserTimeZone';
import { createZonedMoment } from '@src/utils/userTimeZone';

const useUserDateTime = (): {
	timezone: string;
	userMoment: ReturnType<typeof createZonedMoment>;
} => {
	const timezone = useUserTimeZone();
	const userMoment = useMemo(() => createZonedMoment(timezone), [timezone]);
	return { timezone, userMoment };
};

export default useUserDateTime;
